import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ChatRoom } from "../_types/chat-room";
import { Observable } from "rxjs";
import { ChatRoomUsers } from "../_types/chat-room-users";

@Injectable({
    providedIn: 'root',
})
export class ChatRoomUsersService extends Service<ChatRoomUsers> {
    public override type = 'chatRoomUsers';
    public override url = 'communications/chatRoomUsers';

}
